import React from 'react'
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap'
import FormCard from '../common/FormCard'

function DistributorsCreateCard({
  formData,
  errors,
  submitted,
  isSaving,
  errorMessage,
  successMessage,
  onInputChange,
  onSubmit,
}) {
  return (
    <FormCard
      title="Registrar distribuidor"
      onSubmit={onSubmit}
      submitLabel="Registrar"
      isSubmitting={isSaving}
      errorMessage={errorMessage}
      successMessage={successMessage}
    >
      <FormGroup>
        <Label for="name">
          Nombre <span className="text-danger">*</span>
        </Label>
        <Input
          type="text"
          name="name"
          id="name"
          placeholder="Nombre del distribuidor"
          value={formData.name}
          onChange={onInputChange}
          invalid={submitted && !!errors.name}
        />
        {submitted && errors.name && (
          <FormFeedback>{errors.name}</FormFeedback>
        )}
      </FormGroup>
    </FormCard>
  )
}

export default DistributorsCreateCard
